import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 5.99L4.47 19h15.06L12 5.99zM13 18h-2v-2h2v2zm-2-4v-4h2v4h-2z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 2L1 21h22L12 2zm0 3.99L19.53 19H4.47L12 5.99zM11 16h2v2h-2zm0-6h2v4h-2z"
})), 'ReportProblemTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ReportProblemTwoTone.js
// module id = 5794
// module chunks = 2